<div class="query-name-cont" *ngIf="!deletePlan">
  <form
    class="query-name"
    *ngIf="!data || (data && data.action !== 'create' && data.action !== 'add')"
    (ngSubmit)="iSave()"
  >
    <mat-form-field appearance="outline">
      <mat-label>Collection name</mat-label>
      <input matInput [formControl]="namefolio" autocomplete="off" />
      <mat-error *ngIf="namefolio.invalid">Min length 3</mat-error>
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">Save</button>
  </form>

  <div
    class="query-name"
    *ngIf="data && (data.action === 'create' || data.action === 'add')"
  ></div>

  <div class="query-name" *ngIf="data && data.action === 'create'">
    <mat-form-field appearance="outline">
      <mat-label>Query name</mat-label>
      <input matInput [formControl]="namequery" autocomplete="off" />
      <mat-error *ngIf="namequery.invalid">Min length 3</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Collection name</mat-label>
      <input matInput [formControl]="namefolio" autocomplete="off" />
      <mat-error *ngIf="namefolio.invalid">Min length 3</mat-error>
    </mat-form-field>
    <button mat-raised-button class="btn-cancel" (click)="iCancel()">
      Close
    </button>
    <button
      mat-raised-button
      class="btn-add"
      [disabled]="namefolio.invalid || namequery.invalid"
      (click)="iCreate()"
    >
      Create
    </button>
  </div>

  <div class="query-name" *ngIf="data && data.action === 'add'">
    <mat-form-field appearance="outline">
      <mat-label>Query name</mat-label>
      <input matInput [formControl]="namequery" autocomplete="off" />
      <mat-error *ngIf="namequery.invalid">Min length 3</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Collection</mat-label>
      <mat-select [(ngModel)]="selectedCollections" multiple>
        <mat-option
          *ngFor="let collection of collectionsList"
          [value]="collection.uid"
          [disabled]="
            collection.content.length >=
            featureFlagsService.featureFlags.queriesPerCollectionsLimit
          "
        >
          {{ collection.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button class="btn-cancel" (click)="iCancel()">
      Cancel
    </button>
    <button
      mat-raised-button
      class="btn-add"
      [disabled]="selectedCollections.length === 0"
      (click)="iAdd()"
    >
      Add
    </button>
  </div>

  <button
    mat-raised-button
    color="warn"
    (click)="askDelete()"
    *ngIf="data && data.action !== 'create' && data.action !== 'add'"
  >
    Delete
  </button>
</div>

<div class="collection-delete" *ngIf="deletePlan">
  <h2 class="cd-title">Delete “{{ data.name }}”?</h2>
  <p class="cd-text">
    <ng-container *ngIf="deletePlan.exclusive.length > 0">
      Its {{ deletePlan.exclusive.length }}
      {{ deletePlan.exclusive.length === 1 ? 'query is' : 'queries are' }}
      in no other collection and will be deleted too.
    </ng-container>
    <ng-container *ngIf="deletePlan.exclusive.length === 0">
      It has no queries of its own.
    </ng-container>
    <ng-container *ngIf="deletePlan.shared > 0">
      {{ deletePlan.shared }}
      {{ deletePlan.shared === 1 ? 'query is' : 'queries are' }}
      also in other collections and will stay there.
    </ng-container>
  </p>
  <div class="cd-warning" *ngIf="deletePlan.usedBy.length > 0">
    <mat-icon>warning_amber</mat-icon>
    <div>
      <div>
        Used by
        <ng-container *ngFor="let ref of deletePlan.usedBy; let last = last">
          {{ ref.kind }} <strong>{{ ref.name }}</strong
          >{{ last ? '.' : ', ' }}
        </ng-container>
      </div>
      <div class="cd-muted">Deleting the queries also removes them there.</div>
    </div>
  </div>
  <div class="cd-actions">
    <button
      mat-stroked-button
      class="cd-cancel"
      [disabled]="deleting"
      (click)="deletePlan = null"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      class="cd-delete"
      [disabled]="deleting"
      (click)="confirmDelete()"
    >
      Delete collection
    </button>
  </div>
</div>
